import { useEffect, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

const DonationsCarousel = () => {
  const options = {
    items: 3,
    margin: 30,
    smartSpeed: 700,
    loop: true,
    autoplay: 6000,
    nav: true,
    dots: false,
    navText: [
      '<span class="icon-arrow-left"></span>',
      '<span class="icon-arrow-right"></span>'
    ],
    responsive: {
      0: { items: 1, margin: 20 },
      576: { items: 1, margin: 30 },
      768: { items: 2, margin: 30 },
      992: { items: 2, margin: 30 },
      1200: { items: 3, margin: 30 },
    },
  };

  return (
    <section className="donations-one donations-carousel section-space-bottom">
      <div className="container">
        <OwlCarousel className="donations-one__carousel owl-theme" {...options}>
          {donationData.map((donation, index) => (
            <div className="item" key={index}>
              <div className="donation-card">
                <div
                  className="donation-card__bg"
                  style={{ backgroundImage: `url(${donation.bgImage})` }}
                ></div>
                <a href={donation.link} className="donation-card__image">
                  <img src={donation.image} alt={donation.alt} />
                  <div className="donation-card__category">{donation.category}</div>
                </a>
                <div className="donation-card__content">
                  <div className="donation-card__progress">
                    <div className="progress-box">
                      <div className="progress-box__bar">
                        <div
                          className="progress-box__bar__inner"
                          style={{ width: donation.percent }}
                        >
                          <div className="progress-box__number">{donation.percent}</div>
                        </div>
                      </div>
                    </div>
                    <div className="donation-card__progress__bottom">
                      <h5 className="donation-card__progress__title">
                        Raised ₹<span>{donation.raised}</span>
                      </h5>
                      <h5 className="donation-card__progress__title">
                        Goal ₹<span>{donation.goal}</span>
                      </h5>
                    </div>
                  </div>
                  <h3 className="donation-card__title">
                    <a href={donation.link}>{donation.title}</a>
                  </h3>
                  <a href={donation.link} className="donation-card__btn">
                    <span className="cleenhearts-btn__text">Donation Details</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </section>
  );
};

const donationData = [
  {
    bgImage: "assets/images/backgrounds/donation-bg-1-1.png",
    image: "assets/images/donations/donation-1-1.jpg",
    alt: "Give African Children's Good medical support",
    category: "Medical",
    link: "donation-details-right.html",
    percent: "90%",
    raised: "80,050",
    goal: "90,000",
    title: "Give African Children's Good medical support",
  },
  {
    bgImage: "assets/images/backgrounds/donation-bg-1-1.png",
    image: "assets/images/donations/donation-1-2.jpg",
    alt: "Let’s education for children get good life",
    category: "Education",
    link: "donation-details-right.html",
    percent: "65%",
    raised: "80,050",
    goal: "90,000",
    title: "Let’s education for children get good life",
  },
  {
    bgImage: "assets/images/backgrounds/donation-bg-1-1.png",
    image: "assets/images/donations/donation-1-3.jpg",
    alt: "Raise Funds For Clean & Healthy Food",
    category: "Foods",
    link: "donation-details-right.html",
    percent: "75%",
    raised: "80,050",
    goal: "90,000",
    title: "Raise Funds For Clean & Healthy Food",
  },
  {
    bgImage: "assets/images/backgrounds/donation-bg-1-1.png",
    image: "assets/images/donations/donation-1-4.jpg",
    alt: "Medical Support for Rural Areas",
    category: "Medical",
    link: "donation-details-right.html",
    percent: "85%",
    raised: "60,000",
    goal: "70,000",
    title: "Medical Support for Rural Areas",
  },
  {
    bgImage: "assets/images/backgrounds/donation-bg-1-1.png",
    image: "assets/images/donations/donation-1-5.jpg",
    alt: "Education for Underprivileged Children",
    category: "Education",
    link: "donation-details-right.html",
    percent: "50%",
    raised: "40,000",
    goal: "80,000",
    title: "Education for Underprivileged Children",
  },
];

export default DonationsCarousel;
